module.exports = __webpack_public_path__ + "media/gifts/gift-thermage-treatment-9c46447a.png";